import React, { useState } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import axios from "axios";
import {FormattedMessage} from 'react-intl';


const DeleteObject = (props) => {

  const [submitted, setsubmitted] = useState(false);
  const [displayButtons, setDisplayButtons] = useState(true);
  const [message, setmessage] = useState( <FormattedMessage id="message.question" defaultMessage="Are you sure you want to delete " values={{object_type: props.object_type, object_name: props.object_name}} /> );

  const deleteObject = async () => {
    setmessage(<FormattedMessage id="message.delete" defaultMessage="Deletion in progress, please wait..." />);
    setDisplayButtons(false);

    const minDelay = new Promise(resolve => setTimeout(resolve, 1500));

    const errorMessages = {
      gateway: { id: "message.error.del.gw",          def: "Oups, did not work... (err_code del_gw)" },
      patient: { id: "message.error.del.profilefhir",  def: "Oups, did not work... (err_code del_profilefhir)" },
      Device:  { id: "message.error.del.devicereq",    def: "Oups, did not work... (err_code del_devicereq)" },
      group:   { id: "message.error.del.grp",          def: "Oups, did not work... (err_code del_grp)" },
      request: { id: "message.error.del.req",          def: "Oups, did not work... (err_code del_req)" },
    };

    let apiCall;
    if      (props.object_type === "gateway") apiCall = DataServiceSQL.deleteDeviceReq_fhir(props.structure_Id, props.id);
    else if (props.object_type === "patient") apiCall = DataServiceSQL.axios_Delete_Profile_fhir(props.patient.Patient_Data.id_patient);
    else if (props.object_type === "Device")  apiCall = DataServiceSQL.deleteDeviceReq_fhir(props.structure_Id, props.id);
    else if (props.object_type === "group")   apiCall = DataServiceSQL.deleteGroupReq_fhir(props.id);
    else if (props.object_type === "request") apiCall = DataServiceSQL.deleteLinkage_fhir(props.recipient, props.requester);
    else {
      await minDelay;
      setmessage(<FormattedMessage id="message.error.del" defaultMessage="Oups, did not work... (err_code del)" />);
      setDisplayButtons(true);
      setsubmitted(true);
      return;
    }

    try {
      await Promise.all([apiCall, minDelay]);
      if (props.object_type === "group")   props.reloadGroups();
      if (props.object_type === "request") setmessage(<FormattedMessage id="message.canceledRequest" defaultMessage="Request canceled" />);
      else                                 setmessage(<FormattedMessage id="message.success" defaultMessage="Success !" />);
    } catch (e) {
      const err = errorMessages[props.object_type] ?? { id: "message.error.del", def: "Oups, did not work... (err_code del)" };
      setmessage(<FormattedMessage id={err.id} defaultMessage={err.def} />);
    } finally {
      setDisplayButtons(true);
      setsubmitted(true);
    }
  }

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {submitted ? (
            <div>
              <center>
              <h4>{message}</h4>
              <button onClick={props.closeAfterDelete} className="btn btn-success">
                <FormattedMessage id="button.close" defaultMessage="Close" />
              </button>
              </center>
            </div>
          ) 
          :
          (
            <div>
              <center>
                <h4>{message}</h4>
                {displayButtons ? (
                  <div>
                    <button onClick={props.cancelPopup} className="btn btn-danger">
                      <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                    </button>
                    <b>&emsp;</b>
                    <button onClick={deleteObject} className="btn btn-success">
                      <FormattedMessage id="button.submit" defaultMessage="Submit" />
                    </button> 
                  </div>
                )
                :
                null
                }
              </center>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(Constants.styles)(DeleteObject);
